export const useParamId = (param = "id") => {
  const route = useRoute();

  return parseInt(route.params[param] as string);
};
